<template>
  <mf-loading-dialog :loading="$apollo.queries.voucher.loading">
    <edit :voucher="voucher" />
  </mf-loading-dialog>
</template>

<script>
import { QUERY_GET_VOUCHER_BY_ID } from '@/modules/mobile/pontos/graphql'

export default {
  components: {
    Edit: () => import('@/modules/mobile/pontos/views/pages/Edit.vue'),
  },
  data: () => ({
    voucherId: '',
    voucher: {
      title: '',
      description: '',
      money: '',
      points: '',
      status: '',
      initial_date: '',
      final_date: '',
    },
  }),
  computed: {
    editable() {
      return ['DRAFT', 'SCHEDULED'].includes(this.voucher.status)
    },
  },
  apollo: {
    voucher: {
      query: QUERY_GET_VOUCHER_BY_ID,
      notifyOnNetworkStatusChange: true,
      update({ pointsVoucher }) {
        return pointsVoucher || this.voucher
      },
      variables() {
        return {
          id: this.voucherId,
        }
      },
      skip() {
        if (!this.voucherId) return true
        return false
      },
      fetchPolicy: 'no-cache',
    },
  },
  mounted() {
    this.voucherId = this.$route.params.id
    if (this.voucherId?.length !== 24) this.voucherId = ''
  },
}
</script>
